enum DeliveryMethod {
    Post = 'Post',
    Email = 'Email',
    Print = 'Print',
    Peppol = 'Peppol',
    ElectronicInvoice = 'ElectronicInvoice',
}

export default DeliveryMethod;
